function WorldConstructor(){return function(o){o()}}module.exports=WorldConstructor;